module.exports = __webpack_public_path__ + "img/news-6.c049d87b.png";